import { ArrayUtils } from './array.utils';
import { CpfUtils } from './cpf-utils';
import { FileUtils } from './files/file.utils';
import { PhoneUtils } from './phone-utils';
import { StringUtils } from './string.utils';

export class DataTypeUtils {
	static array = ArrayUtils;
	static cpf = CpfUtils;
	static file = FileUtils;
	static phone = PhoneUtils;
	static string = StringUtils;
}
